import { Row } from '@tanstack/react-table';
import { PERMISSION_LABELS } from './cells/PermissionsCell.helpers';
import { TPermissions } from './cells/PermissionsCell.types';
import { TIntroducerListItem } from './UsersTable.types';

export type TFilterOption = { value: string; label: string };

export const COLUMN_IDS = {
  name: 'name',
  status: 'status',
  permissions: 'permissions',
  email: 'email',
  phone: 'phone',
  actions: 'actions',
} as const;

const ROLE_FILTER_OPTIONS: TFilterOption[] = [
  { value: 'regular', label: 'Regular' },
  { value: 'master_broker', label: 'Master broker' },
];

const STATUS_FILTER_OPTIONS: TFilterOption[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export const PERMISSION_FILTER_OPTIONS: TFilterOption[] = PERMISSION_LABELS.map(
  ({ key, label }) => ({ value: key, label }),
);

export const FILTER_OPTIONS_BY_COLUMN: Record<string, TFilterOption[]> = {
  [COLUMN_IDS.name]: ROLE_FILTER_OPTIONS,
  [COLUMN_IDS.status]: STATUS_FILTER_OPTIONS,
  [COLUMN_IDS.permissions]: PERMISSION_FILTER_OPTIONS,
};

export const filterByRole = (
  row: Row<TIntroducerListItem>,
  _columnId: string,
  filterValues?: string[],
) => {
  if (!filterValues || filterValues.length === 0) return true;
  const role = row.original.master_broker ? 'master_broker' : 'regular';
  return filterValues.includes(role);
};

export const filterByStatus = (
  row: Row<TIntroducerListItem>,
  _columnId: string,
  filterValues?: string[],
) => {
  if (!filterValues || filterValues.length === 0) return true;
  const status = row.original.is_active ? 'active' : 'inactive';
  return filterValues.includes(status);
};

export const filterByPermissions = (
  row: Row<TIntroducerListItem>,
  _columnId: string,
  filterValues?: string[],
) => {
  if (!filterValues || filterValues.length === 0) return true;
  const permissions = row.original.permissions;
  return filterValues.some(
    (key) => permissions[key as keyof TPermissions] === true,
  );
};

export const getFullName = (user: TIntroducerListItem) =>
  `${user.first_name} ${user.last_name}`;
